module.exports = __webpack_public_path__ + "img/spintowin.3e2a59e9.jpg";